import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminSessions = () => {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({ client_id: '', session_date: '', duration: '30 min', summary: '', action_items: '', recommendations: '' });
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/admin/clients`, { withCredentials: true }).then(r => setClients(r.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/admin/sessions`, form, { withCredentials: true });
      setSuccess('Session summary created!');
      setForm({ client_id: '', session_date: '', duration: '30 min', summary: '', action_items: '', recommendations: '' });
      setTimeout(() => setSuccess(''), 4000);
    } catch {
      setSuccess('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-sessions">
      <h1 className="portal-page-title">Session Summaries</h1>
      <p className="portal-page-subtitle">Create post-session summaries for clients</p>

      <div className="portal-card">
        <h3>New Session Summary</h3>
        {success && <div className="portal-success" style={{ marginTop: '0.75rem' }}>{success}</div>}
        <form className="portal-form" style={{ marginTop: '1rem' }} onSubmit={handleSubmit} data-testid="session-form">
          <div className="portal-grid-2">
            <div>
              <label>Client *</label>
              <select value={form.client_id} onChange={e => setForm(f => ({ ...f, client_id: e.target.value }))} required>
                <option value="">Select a client</option>
                {clients.map(c => <option key={c.id} value={c.id}>{c.name}{c.company ? ` (${c.company})` : ''}</option>)}
              </select>
            </div>
            <div>
              <label>Session Date *</label>
              <input type="date" value={form.session_date} onChange={e => setForm(f => ({ ...f, session_date: e.target.value }))} required />
            </div>
          </div>
          <div>
            <label>Duration</label>
            <select value={form.duration} onChange={e => setForm(f => ({ ...f, duration: e.target.value }))}>
              <option value="30 min">30 minutes</option>
              <option value="60 min">60 minutes</option>
            </select>
          </div>
          <div>
            <label>Session Summary *</label>
            <textarea value={form.summary} onChange={e => setForm(f => ({ ...f, summary: e.target.value }))} placeholder="Key points discussed and advisor observations" required rows={4} />
          </div>
          <div>
            <label>Action Items</label>
            <textarea value={form.action_items} onChange={e => setForm(f => ({ ...f, action_items: e.target.value }))} placeholder="Next steps for the client" rows={3} />
          </div>
          <div>
            <label>Recommendations</label>
            <textarea value={form.recommendations} onChange={e => setForm(f => ({ ...f, recommendations: e.target.value }))} placeholder="Advisor recommendations" rows={3} />
          </div>
          <button type="submit" className="portal-btn portal-btn-primary" disabled={submitting}>{submitting ? 'Creating...' : 'Create Summary'}</button>
        </form>
      </div>
    </div>
  );
};

export default AdminSessions;
